import { render } from "./BaseRadio.vue?vue&type=template&id=224da68c&scoped=true"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"

import "./BaseRadio.vue?vue&type=style&index=0&id=224da68c&lang=scss&scoped=true"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224da68c"]])

export default __exports__